import script from "./TemplateContentEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateContentEditor.vue?vue&type=script&setup=true&lang=js"

import "./TemplateContentEditor.vue?vue&type=style&index=0&id=6601f6c4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6601f6c4"]])

export default __exports__